import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <h1>תקנון אתר Basta Basket</h1>
      <div className="terms-content">
        <h2>מבוא</h2>
        <p>
          ברוכים הבאים לאתר Basta Basket (להלן: "האתר") המופעל על ידי רון שוקרון, ח.פ 205519598, מכתובת אור הנר 7919000  (להלן: "הנהלת האתר" ו/או "החברה").
          כל שימוש באתר מהווה הסכמה לתקנון זה, על התנאים וההגבלות הכלולים בו.
        </p>
        <p>
        התקנון עלול להשתנות מעת לעת, ועל המשתמש להתעדכן בתקנון בכל כניסה לאתר. גלישה באתר ו/או שימוש בו מכל סוג, כמוהם כהסכמה לתנאי התקנון והתחייבות לפעול על פיהם. מובהר כי התקנון מהווה הסכם משפטית מחייבת לכל דבר ועניין ומחייב את המשתמש על כל שימושיו באתר.
        </p>
        <p>
        ●	האמור בתקנון זה בלשון זכר הוא לשם הנוחות בלבד והתקנון מתייחס לבני שני המינים באופן שווה.
        </p>
        <p>
        ●	השירותים באמצעות האתר כפופים לתנאים המפורטים בתקנון זה.
        </p>
        <p>
        ●	עצם הזמנת שירותים באתר תהווה הצהרה מצד הלקוח כי קרא את הוראות תקנון זה, הבין אותן והסכים להן. התקנון מהווה חוזה מחייב בין המשתמש לבין הנהלת האתר.
        </p>
        <p>
        השירותים - 
        </p>
        <p>
        ●	האתר מאפשר שירותי חיבור בין צרכנים לחקלאים מקומיים לצורך רכישת תוצרת חקלאית טרייה.
        </p>
        <p>
        ●	ניתן להזמין שירותים באמצעות יצירת קשר עם הנהלת האתר בהתאם לזמינותו ומיקומו הגיאוגרפי.
        </p>
        <p>
        ●	ניתן לשלם עבור שירותי האתר באמצעות כרטיס אשראי או Bit בכפוף לאישור הנהלת האתר.
        </p>
        <p>
        ●	מחיר השירותים הינם ללא מע"מ בכפוף לחוק המיסים עבור "חברה בע"מ".
        </p>
        <p>
        ●	הנהלת האתר שומרת לעצמה את הזכות להפסיק את שירותיה בכל עת.
        </p>

        <p>
        ●	הזכאות לשימוש באתר הינה לכל אזרח אשר מלאו לו 18 שנים. הזמנה תתאפשר למי שברשותו חשבון בנק פעיל ו/או בעל כרטיס אשראי ישראלי תקף והינו בעל תיבת דואר אלקטרוני אשר כתובתה תינתן בעת הרכישה באתר. קטין המבצע פעולות ייחשב כקטין אשר קיבל את רשות הוריו/אפוטרופוסיו לביצוע הרכישה באתר.
        </p>
        
        <p>
        ביטולים ושינוי סוגי השירותים - 
        </p>
        
        <p>
        ●	מדיניות ביטול עסקה והחזרת מוצרים, בהתאם לתקנות הגנת הצרכן (ביטול עסקה), התשע"א-2010 וחוק הגנת הצרכן, התשמ"א-1981.
        </p>
        
        <p>
        ●	ניתן לבטל עסקה תוך 14 ימים מיום קבלת המוצר או מיום קבלת מסמך המכיל את פרטי העסקה (המאוחר מביניהם), ובתנאי שלא נעשה שימוש במוצר.
        </p>
        
        <p>
        ●	לביטול עסקה, יש לשלוח הודעה בכתב לכתובת המייל: shukron60@gmail.com
        </p>
        
        <p>
        ●	במקרה של ביטול, יש להחזיר את המוצר באריזתו המקורית, ללא פגם או נזק.
        </p>
        
        <p>
        ●	עם קבלת הודעת הביטול והחזרת המוצר, החברה תשיב ללקוח את הסכום ששולם בניכוי דמי ביטול בסך 5% ממחיר העסקה או 100 ₪, לפי הנמוך מביניהם.
        </p>
        
        <p>
        ●	לא ניתן לקבל החזר כספי עבור שירותים אשר בוצעו.
        </p>
        
        <p>
        ●	האתר יהא רשאי לבטל אספקת הזמנה למשתמש וזאת בהתראה של שעתיים מראש לפחות. במקרה כזה לא יעמוד למשתמש כל טענה כלפי האתר.
        </p>
        
        <p>
        ●	הודעה על ביטול או הפסקה מצד החברה תימסר למשתמש, והחברה תימנע מחיוב כרטיס האשראי של המשתמש או תשיב לו כל סכום ששולם בגין המוצרים ככל ששולם.
        </p>
        
        <p>
        זמינות ומיקום אזורי - 
        </p>
        
        <p>
        ●	זמינות השירותים כפופה למועד אשר נקבע עם הנהלת האתר.
        </p>
        
        <p>
        ●	בכל שאלה או בירור לגבי השירותים ניתן לחייג אל 050-7932705 בטלפון או במייל שירות shukron60@gmail.com .
        </p>
        
        <p>
        מדיניות אספקת מוצרים - 
        </p>
        
        <p>
        ●	החברה תספק את המוצרים שהוזמנו תוך 21 ימי עסקים ממועד אישור העסקה.
        </p>
        
        <p>
        ●	אספקת המוצרים תתבצע לכתובת שסופקה על ידי הרכז הקהילתי בעת ביצוע ההזמנה.
        </p>
        
        <p>
        ●	החברה לא תהיה אחראית לעיכובים באספקה הנובעים מכוח עליון, שביתות, או כל גורם שאינו בשליטתה.
        </p>
        
        <p>
        ●	עלויות המשלוח הינם כפי שהן מופיעות בעמוד התשלום.
        </p>
        
        <p>
        אחריות ושירות - 
        </p>
        
        <p>
        ●	החברה אחראית לטיב המוצרים הנמכרים באתר בהתאם לאחריות היצרן.
        </p>
        
        <p>
        ●	החברה אינה אחראית לנזקים עקיפים או תוצאתיים הנובעים משימוש במוצרים.
        </p>
        
        <p>
        ●	האחריות על שימוש נכון במוצרים היא על הלקוח בלבד.
        </p>
        
        <p>
        ●	הנהלת האתר מסירה מעליה כל אחריות מהתכנים הנכתבים באתר או מהשימוש בהם והשלכותיהם. 
        </p>
        
        <p>
        אבטחת מידע ופרטיות - 
        </p>
        
        <p>
        ●	החברה מתחייבת לשמור על פרטיות המשתמשים באתר.
        </p>
        
        <p>
        ●	המידע האישי שנאסף באתר ישמש אך ורק לצורך ביצוע העסקאות ושיפור השירות.
        </p>
        
        <p>
        ●	החברה לא תעביר מידע אישי של משתמשים לצד שלישי ללא הסכמתם, אלא אם נדרש על פי חוק.
        </p>
        
        <p>
        ●	האתר מאובטח באמצעות שימוש באמצעי אבטחה מתקדמים אשר מטרתם להבטיח שימוש תקין וגלישה בטוחה באתר וכן על מנת לשמור על פרטיות המשתמשים. 
        </p>
        
        <p>
        ●	כל המשתמש באתר ובשירותיו מתחייב כי לא יעשה כל פעילות שיש בה כדי לשבש את פעילות האתר, גניבת מידע על משתמשים ופריצה של מנגנוני האבטחה של האתר. 
        </p>
        
        <p>
        ●	במקרה של שימוש לרעה, הנהלת האתר תפעל נגד כל פעילות בכל דרך חוקית אשר תעמוד לרשותה לרבות חסימת המשתמש מגישה לאתר ונקיטת הליכים משפטיים נגד המשתמש באם יפעל כאמור.
        </p>
        
        <p>
        קניין רוחני - 
        </p>
        
        <p>
        ●	כל זכויות הקניין הרוחני באתר זה הכוללים זכויות יוצרים, זכויות הפצה, סודות מסחריים, סימני המסחר וכל הקניין הרוחני מכל סוג שהוא, הן בנוגע לעיצוב ועמוד האתר, הן באשר לתכנים המופיעים בו הינן רכושה הבלעדי של הנהלת האתר.
        </p>
        
        <p>
        ●	אין להעתיק, לשכפל, להפיץ, לפרסם או להשתמש בכל דרך אחרת במידע כלשהו מן האתר ו/או מהאתר, אלא אם ניתנה הסכמה לכך מראש ובכתב מטעם הנהלת האתר.
        </p>
        
        <p>
        דין וסמכות שיפוט - 
        </p>
        
        <p>
        ●	פרשנותו ואכיפתו של תקנון זה ו/או כל פעולה או סכסוך הנובע ממנו יעשו בהתאם לדין הישראלי בלבד ולבית המשפט המוסמך בתל אביב-יפו תהא מסורה סמכות השיפוט הבלעדית.
        </p>
        
        <p>
        יצירת קשר - 
        </p>
        
        <p>
        ●	לכל שאלה ופנייה ניתן ליצור קשר עם הנהלת האתר בטלפון 050-7932705 או במייל שירות shukron60@gmail.com בשעות הפעילות של האתר.   
        </p>
        
        <p>
        בשימוש באתר ובביצוע רכישה, הנך מאשר כי קראת את התקנון, הבנת אותו והסכמת לתנאיו.
        </p>
        
        <p>

        </p>
        
        <p>

        </p>
        
        <p>

        </p>
        
        
      </div>
    </div>
  );
};

export default TermsOfService;